export enum EAnalyticMode {
  ALL_SESSION = 'ALL_SESSION',
  FIRST_SESSION = 'FIRST_SESSION',
  PAGE_ONLY = 'PAGE_ONLY',
}

export { AnalyticInterval } from '~/utils/analyticInterval';
